// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3rE-I","checkboxCol":"Table_checkboxCol__2QnCH","emailCol":"Table_emailCol__1uBn7","actionCol":"Table_actionCol__2MSQj"};